import { imageUrl } from '@helpers/image';
import { responsiveSizes } from '@helpers/responsive';
import { AnimatePresence } from 'framer-motion';
import React from 'react';
import { ReactComponent as SvgNavSwap } from '@img/icons/repeat-swap.svg';
import S from './NavigationMobile.styles';
import FakeButton from '@stories/Components/Buttons/FakeButton/FakeButton';
import LinkButton from '@stories/Components/Buttons/LinkButton/LinkButton';
const NavigationMobile = ({ activeId, logInCta, items = [], onItemClick, signUpCta, topLinks, canPersonalise, isPersonalised, onPersonalise, accountNavLinks, backBtn, signOutCta, showNavChevrons = false, }) => {
    const flattened = flatMapRecursive(items, item => item.children ?? []);
    const activeItem = flattened.find(item => item.id === activeId);
    const activeItemChildren = activeItem?.children;
    const activeItemParent = flattened.find(item => item.children?.find(child => child.id === activeId));
    return (React.createElement(AnimatePresence, null,
        React.createElement(S.Container, { key: activeItem?.id ?? '0', initial: 'hidden', animate: 'visible', exit: 'hidden', variants: {
                hidden: {
                    position: 'absolute',
                    opacity: 0,
                    width: '100%',
                    transitionEnd: {
                        visibility: 'hidden',
                    },
                    transition: {
                        type: 'tween',
                        ease: 'easeOut',
                    },
                },
                visible: {
                    position: 'relative',
                    opacity: 1,
                    visibility: 'visible',
                    transition: {
                        type: 'tween',
                        ease: 'easeOut',
                    },
                },
            } },
            activeItem && (React.createElement(React.Fragment, null,
                React.createElement(S.BackButton, { onClick: event => {
                        event.preventDefault();
                        onItemClick(activeItemParent?.id ?? '');
                    } },
                    React.createElement(S.BackArrow, null),
                    activeItemParent?.title ? `Back to ${activeItemParent?.title}` : 'Back'),
                React.createElement(S.Title, { href: activeItem.url }, activeItem.title),
                React.createElement(S.Border, null))),
            React.createElement(S.LinkHolder, null,
                (activeItemChildren ?? items).map(item => (React.createElement(S.Item, { key: item.id, hasImage: item.bgImage ? true : false }, item.children?.length ? (React.createElement(S.ItemButton, { onClick: event => {
                        event.preventDefault();
                        onItemClick(item.id);
                    } },
                    item.title,
                    item.description && React.createElement(S.LinkDescription, null, item.description),
                    React.createElement(S.ItemArrow, null))) : (React.createElement(S.ItemLink, { href: item.url },
                    item.bgImage && (React.createElement(S.BgImageHolder, null,
                        React.createElement(S.BgImage, { alt: item.bgImage.altText, draggable: false, loading: 'lazy', role: 'presentation', src: imageUrl(item.bgImage, {}), sizes: [`50vw`].join(', '), srcSet: responsiveSizes([{ value: 50 }], item.bgImage, {
                                heightRatio: 60 / 103,
                            }) }))),
                    React.createElement(S.ContentHolder, null,
                        item.title,
                        item.description && React.createElement(S.LinkDescription, null, item.description),
                        item.external && React.createElement(S.External, null)),
                    React.createElement(S.ItemArrow, { "data-show": showNavChevrons })))))),
                accountNavLinks?.length && accountNavLinks.map(link => (React.createElement(S.AccountItem, { key: link.text },
                    React.createElement(S.ItemLink, { href: link.url },
                        link.text,
                        React.createElement(S.ItemArrow, { "data-show": showNavChevrons }))))),
                (backBtn?.url || signOutCta?.url) && (React.createElement(S.AccountBtnArea, null,
                    backBtn && (React.createElement(LinkButton, { themeOption: backBtn.themeOption, title: backBtn.text, href: backBtn.url, target: backBtn.target })),
                    signOutCta && (React.createElement(LinkButton, { themeOption: signOutCta.themeOption, title: signOutCta.text, href: signOutCta.url, target: signOutCta.target }))))),
            !activeItem && (React.createElement(S.NavBase, null,
                React.createElement(S.NavCtaHolder, null,
                    logInCta && (React.createElement(S.CtaBtn, { themeOption: logInCta?.themeOption, title: logInCta?.text, href: logInCta?.url, target: logInCta?.target })),
                    signUpCta && (React.createElement(S.CtaBtn, { themeOption: signUpCta?.themeOption, title: signUpCta?.text, href: signUpCta?.url, target: signUpCta?.target }))),
                canPersonalise && (React.createElement(S.NavCtaHolder, null,
                    React.createElement(FakeButton, { icon: SvgNavSwap, themeOption: 'green', "aria-label": isPersonalised
                            ? 'Swap to regular Navigation'
                            : 'Swap to personalised Navigation', title: isPersonalised
                            ? 'Swap to regular Navigation'
                            : 'Swap to personalised Navigation', onClick: onPersonalise }, isPersonalised
                        ? 'Swap to regular Navigation'
                        : 'Swap to personalised Navigation'))),
                topLinks && (React.createElement(S.TopLinkHolder, null,
                    React.createElement(S.TopLinkList, null, topLinks.map(link => (React.createElement(S.TopLinkItem, { key: link.text, href: link.url, target: link.target }, link.text)))))))))));
};
export default NavigationMobile;
function flatMapRecursive(array, iteratee) {
    let result = [];
    array.forEach(item => {
        result = result.concat(item);
        if (Array.isArray(iteratee(item))) {
            result = result.concat(flatMapRecursive(iteratee(item), iteratee));
        }
    });
    return result;
}
